export const fields = {
  DRIVING_SCHOOL: 'name',
  DRIVING_SCHOOL_NUMBER: 'number',
  COUNT: 'count',
  PAID: 'paid',
  PCT_FROM_TOTAL_COUNT: 'count_pct',
  PCT_FROM_TOTAL_PAID: 'paid_pct',
  SLUG: 'slug',
}